const MultiSelectDropdown = ({ options, selectedOptions, onChange }) => {
    const handleCheckboxChange = (event) => {
        const { value, checked } = event.target;

        // Prevent unchecking if only 2 checkboxes remain checked
        if (!checked && selectedOptions.length <= 2) {
            alert("At least 2 columns must be selected.");
            return;
        }

        if (checked) {
            onChange([...selectedOptions, value]); // Add selected value
        } else {
            onChange(selectedOptions.filter((item) => item !== value)); // Remove unselected value
        }
    };

    return (
        <div className="custom-multi-select dropdown">
            <button
                className="btn btn-secondary dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{ fontSize: "13px",marginRight:"5px" }}
            >
                Customise Columns
            </button>
            <ul className="dropdown-menu">
                {options.map((option) => {
                    const isLastTwoChecked = selectedOptions.includes(option.value) && selectedOptions.length <= 2;
                    return (
                        <li key={option.value} className="dropdown-item">
                            <label>
                                <input
                                    type="checkbox"
                                    value={option.value}
                                    checked={selectedOptions.includes(option.value)}
                                    onChange={handleCheckboxChange}
                                    disabled={isLastTwoChecked} // Disable only if it's one of the last two checked
                                />
                                {` ${option.label}`}
                            </label>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default MultiSelectDropdown;
